import { AnyAction } from 'redux';

export type Site = {
  abbreviation: string;
  birthdate: number;
  domain: string;
  domainCanonical: string;
  name: string;
  networkName: string;
  networkUUID: string;
  UUID: string;
};

const initialState: Site = {
  abbreviation: '',
  birthdate: 0,
  domain: '',
  domainCanonical: '',
  name: '',
  networkName: '',
  networkUUID: '',
  UUID: '',
};

export default function reducer(state = initialState, action: AnyAction): Site {
  switch (action.type) {
    default: {
      return state;
    }
  }
}
